import { useSelector } from 'react-redux';

function usePurchase() {
  const purchase = useSelector((state) => state.purchase.toJS());
  return purchase;
}

export default usePurchase;
